module.exports = __webpack_public_path__ + "img/nike.c53edd10.svg";